import { ViaCEP } from "@/models/address.model";
import { Organization } from "@/models/organization.model";
import { QueryParams } from "@/models/query-params.model";
import { Status } from "@/models/user.model";
import { AddressRest } from "@/services/rest/address.rest";
import { OrganizationsRest } from "@/services/rest/organizations.rest";
import { GoToRoute } from "@/utils/go-to.util";
import { BehaviorSubject, Observable, map, take } from "rxjs";

export class OrganizationsService {
  constructor(
    private _organizations = new OrganizationsRest(),
    private _address = new AddressRest(),
    private go = new GoToRoute()
  ) {}

  private organizations$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  organizations: Observable<any> = this.organizations$.asObservable();

  private organization$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  organization: Observable<Organization> = this.organization$.asObservable();

  private address$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  address: Observable<ViaCEP> = this.address$.asObservable();

  getOrganizations(queryParams: QueryParams): void {
    this._organizations
      .getOrganizations(queryParams)
      .pipe(
        take(1),
        map((e: any) => {
          e.content.forEach((item: any) => {
            item.status = this.remakeObjectStatus(item.status);
            item.completeName = item.name;
            item.name = this.adjustText(item.name);
          });
          return e;
        })
      )
      .subscribe((response) => {
        this.organizations$.next(response);
      });
  }
  getOrganizationById(id: string): void {
    this._organizations
      .getOrganizationById(id)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.organization$.next(response);
        },
        error: (e) => {
          this.go.redirectToPage("formsOrganizations");
        },
      });
  }
  getAddressByCEP(cep: string): void {
    this._address.getAddressByCEP(cep).subscribe((response) => {
      this.address$.next(response);
    });
  }
  remakeObjectStatus(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getStatus(item);
    status.class = this.getStatusColor(item);
    status.value = item;
    return status;
  }
  getStatus(status: string): string {
    if (status == Status.ACTIVATED) {
      status = "Ativo";
    } else if (status == Status.INACTIVATED) {
      status = "Inativo";
    }
    return status;
  }

  getStatusColor(status: string): string {
    if (status == Status.ACTIVATED) {
      status = "bg-h-success-100 text-h-success-500";
    } else if (status == Status.INACTIVATED) {
      status = "bg-h-neutral-200 text-h-neutral-800";
    }
    return status;
  }
  statusChange(status: string): string {
    switch (status) {
      case Status.ACTIVATED:
        return Status.INACTIVATED;
      case Status.INACTIVATED:
        return Status.ACTIVATED;
      case Status.BLOCKED:
        return Status.ACTIVATED;
    }
    return status;
  }
  adjustText(text: string): string {
    if (text.length > 20) {
      text = text.substring(0, 45) + "...";
    }
    return text;
  }
}
